// @flow
import { invalidZipFields } from './completion';

export const FORM_ID = 'recert-application-form';

const INVALID = 'Invalid value';

type FormApi = {
  trigger: () => Promise<boolean>,
  getValues: () => Object,
  getFieldState: (name: string) => { error?: { type: string } },
  setError: (name: string, error: { type: string, message: string }) => void,
  clearErrors: (names: Array<string>) => void,
};

/**
 * Saving keeps progress, so only a malformed value blocks it. Unanswered required questions are
 * left out of the check and not highlighted.
 */
export const validateForSave = async ({
  trigger,
  getValues,
  getFieldState,
  clearErrors,
}: FormApi): Promise<boolean> => {
  await trigger();
  const names = Object.keys(getValues());
  const errorType = (name) => getFieldState(name).error?.type;
  clearErrors(names.filter((name) => errorType(name) === 'required'));
  return names.every((name) => !errorType(name));
};

/**
 * Shows every answer that keeps the recert from being completed, then brings the first one into
 * view. The zip format only matters for completion, so it has no field rule and is flagged here.
 */
export const revealBlockingAnswers = async ({
  trigger,
  getValues,
  setError,
  onInvalid,
}: FormApi & { onInvalid: () => void }): Promise<void> => {
  await trigger();
  invalidZipFields(getValues()).forEach((name) =>
    setError(name, { type: 'validate', message: INVALID }),
  );
  onInvalid();
  // The toast takes focus as it mounts, and the form scrolls inside its own box. Radio groups
  // mark the error on their wrapper, not with aria-invalid on the input.
  window.setTimeout(() => {
    const first = document
      .getElementById(FORM_ID)
      ?.querySelector('[aria-invalid="true"], .Mui-error input');
    if (!first) return;
    first.scrollIntoView?.({ block: 'center' });
    first.focus({ preventScroll: true });
  }, 0);
};
